import styled from '@emotion/styled';

export const ExclusionsWrapper = styled.div`
    position: absolute;
    top: 0px;
    left: 0;
    z-index: 500;
`;

export const ExclusionsModalBody = styled.div`
    background-color: white;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;
